import React, { useState, useEffect } from "react";
import Slider from "rc-slider";
// import "rc-slider/assets/index.css";
// import "./style.scss";
import { useGet } from "~hooks/useQuery";
import { useIntl } from "react-intl";
const TealPriceRangeSlider = ({
  min = 0,
  max = 40,
  currency = 'EUR',
  step = 1,
  defaultValues = 40,
  location = null,
  onChange = () => { },
}) => {
  const finalDefaultValue = defaultValues === 0 || defaultValues === undefined ? 40 : defaultValues;
  const intl = useIntl();
  const [range, setRange] = useState([min, finalDefaultValue]);

  const { data, isLoading } = useGet({
    name: 'amount-distribution',
    params: {
      start: min,
      end: max,
      role: 'Worker',
      latitude: location?.latitude,
      longitude: location?.longitude,
      currency_code: currency,
    },
    shouldExecute: true,
  }, []);

  // Extract histogram data from API response
  const histogramData = data?.data ? data.data.map(item => item.frequency) : [];

  // Calculate values for rendering
  const totalBars = histogramData.length;
  const stepSize = 40 / (totalBars || 1);
  const maxFrequency = histogramData.length > 0 ? Math.max(...histogramData) : 0;
  const scaleFactor = maxFrequency > 0 ? 50 / maxFrequency : 1; // Scale to max height of 50px

  return (
    <div className="teal-slider-wrapper">
      <h4>{intl.formatMessage({ id: 'containers.workers.filters.price.label', defaultMessage: 'Hourly rate' })}</h4>
      <div className="c-price-labels">
        <div className="c-label-wrap">
          <div className="c-pric-label">Minimum</div>
          <div className="c-label">{intl.formatNumber(min, { style: 'currency', currency })}</div>
        </div>
        <div className="c-label-wrap">
          <div className="c-pric-label">Maximum</div>
          <div className="c-label">{intl.formatNumber(range[1], { style: 'currency', currency })}</div>
        </div>
      </div>
      <div className="histogram">
        {isLoading ? (
          <div className="loading">{intl.formatMessage({ id: 'containers.workers.filters.price.loading', defaultMessage: 'Loading...' })}</div>
        ) : (
          histogramData.map((val, idx) => {
            const value = idx * stepSize;
            const isBefore = value < range[0];
            const isInRange = value >= range[0] && value <= range[1];

            return (
              <div
                key={idx}
                className={`bar ${isBefore ? "before" : isInRange ? "in-range" : "after"}`}
                style={{ height: `${val * scaleFactor}px` }}
              ></div>
            );
          })
        )}
      </div>

      <Slider
        range
        min={min}
        max={max}
        step={step}
        value={range}
        onChange={setRange}
        onChangeComplete={onChange}
        trackStyle={[
          { backgroundColor: "#23AFB3", height: 2 },
          { backgroundColor: "#00A699", height: 2 }
        ]}
        handleStyle={[
          {
            borderColor: "#dddddd",
            backgroundColor: "#fff",
            opacity: 1,
            borderWidth: 1,
            height: 27,
            width: 27,
            marginTop: -13,
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
          },
          {
            borderColor: "#dddddd",
            backgroundColor: "#fff",
            opacity: 1,
            borderWidth: 1,
            height: 27,
            width: 27,
            marginTop: -13,
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
          }
        ]}
        railStyle={{ backgroundColor: "#eee", height: 2 }}
      />
    </div>
  );
};

export default TealPriceRangeSlider;
